export const GET_MY_VIRTUAL_CARD_START = 'GET_MY_VIRTUAL_CARD_START';
export const GET_MY_VIRTUAL_CARD_SUCCESS =
  'GET_MY_VIRTUAL_CARD_SUCCESS';
export const GET_MY_VIRTUAL_CARD_ERROR = 'GET_MY_VIRTUAL_CARD_ERROR';
export const GET_MY_VIRTUAL_CARD_END = 'GET_MY_VIRTUAL_CARD_END';
